import ClearIcon from '@mui/icons-material/Clear'
import { Chip } from '@mui/material'

export default function ClearFileChip({
  onClick,
  disabled,
}: {
  disabled?: boolean
  onClick?: () => void
}) {
  return (
    <Chip
      clickable
      aria-label="clear"
      disabled={disabled}
      size="medium"
      label="Clear"
      onClick={onClick}
      icon={<ClearIcon />}
    />
  )
}
